import { Component, OnInit, inject } from '@angular/core';
import { Language, LanguageService } from '../../services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lang-select',
  templateUrl: './lang-select.component.html',
  styleUrls: ['./lang-select.component.scss'],
})
export class LangSelectComponent implements OnInit {
  public listOfLanguages: Array<{ label: string; value: Language }> = [
    { label: 'EN', value: 'en' },
    { label: 'ES', value: 'es' },
  ];

  public selectedLanguage!: Language;

  private _languageService = inject(LanguageService);
  private _translateService = inject(TranslateService);

  public ngOnInit(): void {
    this.selectedLanguage = this._languageService.language || 'en';
  }

  public selectLanguage(language: Language): void {
    this.selectedLanguage = language;
    this._languageService.setLanguage(language);
    this._translateService.use(language);
  }

  public getLangIcon(): string {
    return `/assets/icons/${this.selectedLanguage || 'en'}.png`;
  }
}
